import { useLocalStorage } from "../../shared/hooks/useLocalStorage";
import { useUserId } from "../../query/hooks/helpers";
import { useSetWSStore, useWSStore } from "../../store";
import { useCallback, useLayoutEffect, useState } from "react";

export const useSidebarsShowState = () => {
  const userId = useUserId();

  const [sideNavOpened, setSideNavOpened] = useLocalStorage(
    userId + ":navigation-expanded",
    true
  );

  const store = useWSStore();
  const setStore = useSetWSStore();

  const isBulkReviewVisible = store.bulkReviewVisible && !!store.bulkReview;

  const [tempNavOpened, setTempNavOpened] = useState(sideNavOpened);

  useLayoutEffect(() => {
    if (isBulkReviewVisible) {
      setTempNavOpened(false);
    }
  }, [isBulkReviewVisible]);

  const setIsBulkReviewVisible = useCallback(
    (bulkReviewVisible: boolean) => {
      setStore({ bulkReviewVisible });
    },
    [setStore]
  );

  const setIsSideNavOpened = useCallback(
    (sideNavOpened: boolean) => {
      if (isBulkReviewVisible) {
        setTempNavOpened(sideNavOpened);
        setSideNavOpened(sideNavOpened);
      } else {
        setSideNavOpened(sideNavOpened);
      }
    },
    [isBulkReviewVisible, setSideNavOpened, setTempNavOpened]
  );

  const isSideNavOpened = isBulkReviewVisible ? tempNavOpened : sideNavOpened;

  return {
    isSideNavOpened,
    setIsSideNavOpened,
    isBulkReviewVisible,
    setIsBulkReviewVisible
  };
};
